module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/roosters.4379b00.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/roosters.png
// module id = j9Vv
// module chunks = 0